import Component from 'vue-class-component';
import ProductTableElement from '../ProductTableElement/ProductTableElement';
import ProductListAbstract from '../ProductAbstract/ProductListAbstract';

@Component({
    components: {
        ProductTableElement,
    }
})
export default class ProductTable extends ProductListAbstract {
    headers = [
        {
            text: '',
            sortable: false,
            width: 80
        },
        {
            text: 'Артикул',
            sortable: false,
            width: 125
        },
        {
            text: 'Наименование',
            sortable: false,
        },
        {
            text: 'В наличии',
            sortable: false,
            align: 'center',
        },
        {
            text: 'Кол-во',
            sortable: false,
            align: 'center',
        },
        {
            text: 'Кол-во в\nупаковке/коробке',
            sortable: false,
            align: 'left',
            width: 100
        },
        {
            text: 'Цена',
            align: 'center',
            sortable: false,
            width: 152
        },
        {
            text: '',
            sortable: false,
            width: 110
        },
    ]
    mounted() {
        if(this.unsecured) this.headers.unshift({text: '',sortable: false, width: 40})
    }
}